import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;

export const ExpandedProcessWrapper = styled.div<IButtonProps>`
    display: flex;
    flex: 0 0 50%;
    flex-direction: column;
    justify-content: left;
    margin: 0 0 0 10px;
    ${({ includeBorder }) => includeBorder && css``}
`;

export interface IButtonProps {
    includeBorder?: boolean;
}

export const ToolboxProcessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-content: left;
    justify-content: left;
`;

export const ProcessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    margin: 10px;
`;

export const InstanceSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-content: left;
    justify-content: left;
    padding-left: 20px;
`;

export const InstanceItemWrapper = styled.div`
    margin-left: 10px;
`;

export const HeadingWrapper = styled.div`
    display: flex;
    align-content: left;
    justify-content: left;
    font-size: 1.25rem;
    font-weight: 300;
    margin: 0 0 10px 0;
`;
